export const stundenpensum = {
  monat: 'monat',
  woche: 'woche',
} as const;

export type Stundenpensum = keyof typeof stundenpensum;
